// extracted by mini-css-extract-plugin
export var acitonButtons = "_hs-0";
export var additionalIcon = "_hs-f";
export var block = "_hs-1";
export var blockContent = "_hs-7";
export var blockDescription = "_hs-8";
export var blockIcon = "_hs-9";
export var blockTitle = "_hs-6";
export var border = "_hs-a";
export var center = "_hs-l";
export var edge = "_hs-b";
export var edgeLabel = "_hs-c";
export var edgePath = "_hs-d";
export var error = "_hs-e";
export var flowchart = "_hs-g";
export var flowchartContent = "_hs-h";
export var highlighted = "_hs-3";
export var hover = "_hs-4";
export var icon = "_hs-i";
export var left = "_hs-m";
export var navButton = "_hs-j";
export var navButtons = "_hs-k";
export var right = "_hs-n";
export var selected = "_hs-2";
export var small = "_hs-5";